import { render, staticRenderFns } from "./CreateOrg.vue?vue&type=template&id=6bf4537d&scoped=true&"
import script from "./CreateOrg.vue?vue&type=script&lang=js&"
export * from "./CreateOrg.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrg.vue?vue&type=style&index=0&id=6bf4537d&lang=less&scoped=true&"
import style1 from "./CreateOrg.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf4537d",
  null
  
)

export default component.exports